module.exports = __webpack_public_path__ + "img/2021compiler3.ba57727f.png";